import { useFormik } from "formik";
import * as Yup from "yup";
import ResetPasswordSvg from "../../assets/img/reset-password.svg";
import { FormError } from "../../shared/components/validationMessage";
import request from "../../shared/utils/request";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { LoadingButton } from "../../shared/components/loadingButton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ResetPassword = () => {
  const query = new URLSearchParams(useLocation().search);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      password: "",
      c_password: "",
      token: query.get("token"),
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("New Password is required"),
      c_password: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);
        const response = await request.post("studentsetPassword", values);
        if (response?.data?.status) {
          navigate("/registration-completed");
        } else {
          toast.error(response?.data?.message, {
            autoClose: 4000,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    },
  });

  return (
    <section id="login-container">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-5">
            <img
              src={ResetPasswordSvg}
              className="img-fluid"
              alt="Reset Password"
            />
          </div>
          <div className="col-md-6">
            <div className="login-Card">
              <h1 className="text-center py-3">Reset Password</h1>
              <form onSubmit={formik.handleSubmit}>
                <div className="form-group mb-3">
                  <label htmlFor="password">New Password</label>
                  <input
                    type="password"
                    className="form-control eduform"
                    id="password"
                    placeholder="New Password"
                    {...formik.getFieldProps("password")}
                  />
                  <FormError
                    touched={formik.touched.password}
                    error={formik.errors.password}
                  />
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="c_password">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control eduform"
                    id="c_password"
                    placeholder="Confirm Password"
                    {...formik.getFieldProps("c_password")}
                  />
                  <FormError
                    touched={formik.touched.c_password}
                    error={formik.errors.c_password}
                  />
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <LoadingButton isLoading={loader} buttonText={"Submit"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
